
/*
    NOT YET IMPLEMENTED
*/

import React, { useContext } from "react";

import MainContext from "../MainContext";
import DataContext from "../DataContext";

import VerticalLayout from "../Components/VerticalLayout";
import SubNav from "../Components/SubNav";
import SingleOpenList from "../Components/SingleOpenList";

const MessagesSentPageContainer = (props) => {
    const context = useContext(DataContext);

    return (
        <MessagesSentPage {...props}
            dataReload={context.dataReload}
            setReload={context.setReload}
        />
    )
};

export default MessagesSentPageContainer;


class MessagesSentPage extends React.Component {
    static contextType = MainContext;

    render(){
        return (
            <div style={{display: "grid", placeItems:"center", marginTop: "5vh"}}>
                <h2>
                    COMING SOON!
                </h2>
            </div>
        )
    }
}